import { isFunc } from "../fn";
import { getOperationName } from "../parsers/getOperationName";

const buildQuery = (queryBuilder, variables) =>
	isFunc(queryBuilder) ? { query: queryBuilder(variables) } : { query: queryBuilder, variables };

/**
 * Type Operation Builder Function
 *
 * @template {{}} V
 * @typedef {(variables: V) => string} OperationBuilderFn
 */

/**
 * Type GraphQL Operation
 *
 * @template {{}} V
 * @typedef {{ operationName: string, query: string, variables?: V }} Operation
 */

/**
 * Type Fetch
 *
 * @typedef {typeof global.fetch} Fetch
 */

/**
 * Creates a GraphQL - operation object
 *
 * @template {{}} V
 * @type {(queryBuilder: string|OperationBuilderFn<V>, variables: V) => Operation<V>}
 */
export const gqlOperation = (queryBuilder, variables) => {
	const queryAndVars = buildQuery(queryBuilder, variables);
	const operationName = getOperationName(queryAndVars.query);
	return operationName ? { operationName, ...queryAndVars } : queryAndVars;
};

/**
 * Creates Simple GraphQL Fetcher
 *
 * @template {{}} V
 * @template R
 * @type {(gqlHost: string, speficFetch?: Fetch) => (
 *   operationBuilder: string|OperationBuilderFn<V>,
 * 	 variables: V,
 * 	 options: { headers: object }
 * ) => Promise<R>}
 */
export const gqlFetch = (uri, specificFetch = global.fetch) => (
	queryBuilder,
	variables,
	{ headers, ...options } = {},
) =>
	specificFetch(uri, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: "application/json",
			...headers,
		},
		body: JSON.stringify(gqlOperation(queryBuilder, variables)),
		...options,
	})
		.then(res => res.json())
		.then(({ data, errors }) => (errors ? Promise.reject(errors[0] || errors) : data));

/**
 * emulates gql-tag to add IDE support for non-parsed queries
 *
 * @type {(strings: string[]) => string} */
export const gql = String.raw;
